module.exports = __webpack_public_path__ + "img/rsz_img_0531.a207219d.jpg";